// src/pages/AcceptInvitePage.tsx
import React, { useEffect } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Spinner
} from 'reactstrap';
import { useAcceptInvite } from '../../../../hooks/useAcceptInvite';
import { Lock, ArrowLeft } from 'react-feather';
import { toast } from 'react-toastify';
import { H2, Image, P } from '../../../../AbstractElements';
import { dynamicImage } from '../../../../Utils';

export default function AcceptInvitePage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const userId = searchParams.get('userId') ?? '';
  const groupId = searchParams.get('groupId') ?? '';
  const groupName = searchParams.get('groupName') ?? '';

  const {
    groupTitle,
    fetchingGroup,
    loading,
    code,
    error,
    success,
    setCode,
    submit,
    reset
  } = useAcceptInvite({ userId, groupId, onSuccess: (data: any) => { } });

  useEffect(() => {
    // friendly toast if we arrived without required params
    if (!userId || !groupId) {
      toast.warning('Invite link missing userId or groupId. Please open the invite you received via email.');
    }
  }, [userId, groupId]);

  // detect theme quickly from body class
  const isDark = typeof document !== 'undefined' && (document.body.classList.contains('dark') || document.documentElement.getAttribute('data-theme') === 'dark');

  // small helper for pressing Enter
  const onSubmitForm = async (e: React.FormEvent) => {
    e.preventDefault();
    await submit();
  };

  return (
    <Container className="p-0" fluid style={{ backgroundColor: 'black' }}>

      <Row className="m-0">

        <Col xs={12} className="p-0">

          <div className="login-card login-dark">
            <div>
              <div>
                <Link className="logo" to={`${process.env.PUBLIC_URL}/dashboard/default`}>
                  <Image
                    height={50}
                    className="for-light"
                    src={dynamicImage(`logo/divine_comedy.webp`)}
                    alt="looginpage"
                  />
                  <Image
                    height={50}
                    className="for-dark"
                    src={dynamicImage(`logo/divine_comedy.webp`)}
                    alt="looginpage"
                  />
                </Link>


                <div className="login-main">
                  {/* <Row> */}
                  {/* <Col md={8} lg={7} className="mx-auto"> */}
                  {/* <Card style={{ borderRadius: 12, overflow: 'hidden', boxShadow: '0 10px 30px rgba(2,6,23,0.06)' }}> */}
                  {/* header */}


                  {/* <CardBody style={{ padding: 20, background: isDark ? '#0b1220' : '#fff' }}> */}
                  <Form className="theme-form" onSubmit={onSubmitForm}>
                    <H2 className="text-center">Accept Invite</H2>
                    <P className="text-center"> Enter the 6-digit verification code you received by email</P>
                    <FormGroup>
                      <Label for="code" style={{ fontWeight: 600 }}>Verification code</Label>
                      <div style={{ display: 'flex', gap: 12, alignItems: 'center', marginTop: 8 }}>
                        <div style={{
                          flex: 1,
                          display: 'flex',
                          alignItems: 'center',
                          // background: isDark ? '#071024' : '#f7fafc',
                          padding: '12px 16px',
                          borderRadius: 10,
                          // border: `1px solid ${error ? '#f44336' : (isDark ? 'rgba(255,255,255,0.04)' : '#e6eef7')}`
                        }}>
                          <Lock size={18} style={{ marginRight: 10, opacity: 0.6 }} />
                          <Input
                            id="code"
                            type="text"
                            bsSize="lg"
                            value={code}
                            onChange={(e) => setCode(e.target.value)}
                            placeholder="Enter 6-digit code"
                            aria-label="Verification code"
                            style={{
                              border: 'none',
                              outline: 'none',
                              fontSize: code ? 16 : 9, 
                              fontWeight: code ? 600 : 400
                            }}
                          />

                        </div>

                        <div style={{ width: 160 }}>
                          <Button
                            color="primary"
                            size="lg"
                            block
                            onClick={() => submit()}
                            disabled={loading}
                            style={{ borderRadius: 10, height: 52, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                          >
                            {loading ? <><Spinner size="sm" />&nbsp;Verifying...</> : 'Verify code'}
                          </Button>
                        </div>
                      </div>

                      {error && <div style={{ color: '#f44336', marginTop: 8, fontSize: 13 }}>{error}</div>}
                      {success && <div style={{ color: '#16a34a', marginTop: 8, fontSize: 13 }}>{success}</div>}

                      <div style={{ marginTop: 16, color: isDark ? 'rgba(255,255,255,0.65)' : '#6b7280', fontSize: 13 }}>
                        If the code doesn't work, double-check the email you received or ask your group administrator for assistance.
                      </div>
                    </FormGroup>
                  </Form>

                  <div style={{ marginTop: 18, display: 'flex', gap: 10, alignItems: 'center' }}>
                    <Button color="secondary" outline onClick={() => { reset(); }} disabled={loading}>
                      Clear
                    </Button>
                    {/* <Button color="link" onClick={() => { reset(); setCode(''); }} style={{ padding: 0 }}>Clear</Button> */}
                    {/* <div style={{ marginLeft: 'auto', fontSize: 13, color: isDark ? 'rgba(255,255,255,0.6)' : '#9ca3af' }}>
                Need help? Contact support.
              </div> */}
                  </div>
                  {/* </CardBody> */}

                  <div style={{ padding: '12px 20px', textAlign: 'center', fontSize: 13, color: '#9ca3af' }}>
                    This invitation is valid until accepted. By accepting you will be added to the group's participants list.
                  </div>
                  {/* </Card> */}
                  {/* </Col> */}
                  {/* </Row> */}
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
}
